import React, { ReactType } from 'react';
import sanitizeHtml from 'sanitize-html';

export type SanitizedHtmlProps = {
  readonly innerHTML: string | JSX.Element;
  readonly tagName?: ReactType;
};

export function SanitizedHtml({
  innerHTML,
  tagName: Component = 'span'
}: SanitizedHtmlProps) {
  if (typeof innerHTML === 'string') {
    return (
      <Component
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(innerHTML) }}
      />
    );
  } else {
    return null;
  }
}
